import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListBookService,
	getListBookServiceAsync,
	GetListBookServicePayload,
} from "./bookService.slice";
import { message } from "antd";
import api from "service/apiService";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";

// Get list
function* getListBookServiceSaga(
	action: PayloadAction<GetListBookServicePayload>,
) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		const { query } = action.payload;
		let { skip } = query;
		const { take } = query;
		skip = skip * take;
		try {
			const response = await api.get("/dashboard/banners", {
				...query,
				skip,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListBookService.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}
function* watchGetListBookService() {
	yield takeLatest(getListBookServiceAsync, getListBookServiceSaga);
}

const bannerSaga = [watchGetListBookService()];
export default bannerSaga;
